import React from "react";
import Link from "next/link";
import { BiPhone, BiEnvelope, BiLogoLinkedin } from "react-icons/bi";
import { useTranslations } from "../../locales/useTranslations";

const SoftwareDevelopmentInfoAndCTA = () => {
  const { t } = useTranslations();

  return (
    <>
      <div className="service-details pb-70">
        <div className="container">
          <div className="service-details-content">
            <div className="pt-35">
              <h2>{t('softwareDevelopment_info_agility_title')}</h2>
              <p>{t('softwareDevelopment_info_agility_description')}</p>
              <ul>
                <li>{t('softwareDevelopment_info_agility_benefits_1')}</li>
                <li>{t('softwareDevelopment_info_agility_benefits_2')}</li>
                <li>{t('softwareDevelopment_info_agility_benefits_3')}</li>
              </ul>
            </div>

            <div className="pt-35">
              <h2>{t('softwareDevelopment_info_customSoftware_title')}</h2>
              <p>
                {t('softwareDevelopment_info_customSoftware_description')}
              </p>
            </div>
            <div className="pt-35">
              <h3>{t('softwareDevelopment_info_whyChoose_title')}</h3>
              <p>
                {t('softwareDevelopment_info_whyChoose_description')}
              </p>
            </div>

            <div className="service-details pt-35">
              <div className="service-details-info ">
                <div className="large-info-box">
                  <h4>{t('softwareDevelopment_cta_title')}</h4>
                  <span>{t('softwareDevelopment_cta_description')}</span>
                </div>

                <div className="single-info-box">
                  <h4>{t('softwareDevelopment_cta_contact_title')}</h4>
                  <ul className="social">
                    <li>
                      <a href="tel://+4943170577024" target="_blank">
                        <BiPhone />
                      </a>
                    </li>
                    <li>
                      <a href="mailto:info@simplify-data.de" target="_blank">
                        <BiEnvelope />
                      </a>
                    </li>
                    <li>
                      <a href="https://www.linkedin.com/company/simplify-data-gmbh" target="_blank">
                        <BiLogoLinkedin />
                      </a>
                    </li>
                  </ul>
                </div>

                <div className="single-info-box">
                  <Link href="/kontakt/" className="default-btn">
                    {t('softwareDevelopment_cta_contact_button')}
                  </Link>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </>
  );
};

export default SoftwareDevelopmentInfoAndCTA;
